import { Panel } from '@studiometa/ui';
import Collapse from './Collapse/index.js';

/**
 * LessonPanel component
 */
export default class LessonPanel extends Panel {
  /**
   * Component Configuration
   */
  static config = {
    name: 'LessonPanel',
    options: {
      ...Panel.config.options,
      currentChapter: {
        type: String,
        default: '0',
      },
    },
    components: {
      Collapse,
    },
  };

  /**
   * Open the current CollapseItem from the currentChapter options
   */
  open() {
    super.open();

    this.$children.Collapse[0].$children.CollapseItem[this.$options.currentChapter].open();
  }
}
